import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { mediaApiSlice } from '../../../contentTypes/mediaApiSlice';
import { mediaSlidersApiSlice } from '../../../forYou/mediaSlidersApiSlice';
import { resetMediaSliders } from '../../../forYou/mediaSlidersSlice';
import { Button } from '../../../shared/components/button/Button';
import ChevronBackBtn from '../../../shared/components/styledComponents/chevronBackBtn/ChevronBackBtn';
import { AuthContext } from '../../../shared/context/auth-context';
import { useHttpClient } from '../../../shared/hooks/http-hook';
import { GreenCheckOverlay } from '../../../shared/modal/greenCheckOverlay/GreenCheckOverlay';
import De from '../../images/De.svg';
import En from '../../images/En.svg';
import Sv from '../../images/Sv.svg';
import './LanguagesRightMenu.css';
import { LanguageOption } from './LanguageOption';

type LanguagesRightMenuProps = {
  hide: boolean;
  profile: any;
  changeMenu: (_menuIndex: number, _action: string) => void;
  saveChanges: (_profile: any) => void;
};

export function LanguagesRightMenu({
  hide,
  profile,
  changeMenu,
  saveChanges,
}: LanguagesRightMenuProps) {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const { sendRequest } = useHttpClient();
  const [userProfile, setUserProfile] = useState(profile);
  const [showGreenCheck, setShowGreenCheck] = useState(false);
  const [activeLang, setActiveLang] = useState(profile?.language || 'en');

  const showGreenCheckOverlay = () => {
    setShowGreenCheck(true);
    setTimeout(() => {
      setShowGreenCheck(false);
    }, 2000);
  };

  useEffect(() => {
    setUserProfile((prevState) => ({
      ...prevState,
      language: activeLang,
    }));
  }, [activeLang]);

  const saveProfile = async () => {
    if (userProfile && auth.token) {
      let responseData;
      try {
        responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/users/profile`,
          'POST',
          JSON.stringify({
            profile: userProfile,
          })
        );
      } catch (err) {
        console.error(err);
      }
      if (responseData) {
        showGreenCheckOverlay();
        auth.languageHandler(activeLang);
        saveChanges(userProfile);
        dispatch(resetMediaSliders());
        dispatch(
          mediaSlidersApiSlice.util.invalidateTags([
            { type: 'MediaSliders', id: 'LIST' },
            { type: 'Feature', id: 'LIST' },
            { type: 'TakeAction', id: 'LIST' },
          ])
        );
        dispatch(
          mediaApiSlice.util.invalidateTags([
            { type: 'SingleMedia', id: 'LIST' },
            { type: 'Masterclass', id: 'LIST' },
            { type: 'Programme', id: 'LIST' },
          ])
        );
      }
    }
  };

  return (
    <>
      {showGreenCheck && <GreenCheckOverlay text={t('saved_changes_successfully')} />}
      {userProfile && (
        <div className="edit-field lang">
          {hide && (
            <div className="btn-cont ">
              <ChevronBackBtn onClick={() => changeMenu(0, 'back')} />
            </div>
          )}
          <fieldset className="language-selection-fieldset" aria-labelledby="edit-title">
            <h2 className="edit-title" id="edit-title">
              {t('PL001')}
            </h2>
            <LanguageOption
              id="en"
              language={{ src: En, name: t('PL002') }}
              active={activeLang === 'en'}
              onChange={() => setActiveLang('en')}
            />
            <LanguageOption
              id="de"
              language={{ src: De, name: t('PL003') }}
              active={activeLang === 'de'}
              onChange={() => setActiveLang('de')}
            />
            <LanguageOption
              id="sv"
              language={{ src: Sv, name: t('PL004') }}
              active={activeLang === 'sv'}
              onChange={() => setActiveLang('sv')}
            />
          </fieldset>
          <Button isFullWidth className="margin-top-24" onClick={saveProfile}>
            {t('S017')}
          </Button>
        </div>
      )}
    </>
  );
}
